import "./Header.css";

const Header = () => {
  return (
    <div className="toolbar">
      <div className="toolbar-text">
        <h5>SQL Runner</h5>
      </div>
    </div>
  );
};

export default Header;
